export { default } from "./Modal";
export { Consumer as IsModalOpenConsumer } from "./isOpenContext";
